import React from 'react'
import Main from './Main'

const Login = () => {
  return <Main />
}

export default Login
